import React, { useState } from 'react';
import { Link, useLocation } from "react-router-dom";
import BhashiniTranslator from './BhashiniTranslator';
export default function Header() {
    const [isNavbarVisible, setNavbarVisible] = useState(false);
    const location = useLocation();


    const handleToggle = () => {
        const navbar = document.getElementById("navbarNav");
        if (!isNavbarVisible) {
            navbar.classList.add("show");
        } else {
            navbar.classList.remove("show");
        }
        setNavbarVisible(!isNavbarVisible);
    };

    const handleClose = () => {
        const navbar = document.getElementById("navbarNav");
        navbar.classList.remove("show");
        setNavbarVisible(false)
    }


    return (
        <div className='fixed-top'>


<div
  style={{
    background: "#eaf1f5",
    zIndex: 99999,
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "0 12px",
  }}
>
  <BhashiniTranslator />
</div>


            <header className="header-container header-lg">
                <div className="container-fluid position-relative">
                    <div className="row gx-0 align-items-center">
                        <div className="col-xl-4 col-lg-5 col-md-5">
                            <Link to="/" style={{ textDecoration: 'none' }}>
                                <div className='mainheadertitle'>
                                    <img src="img/mplogo.png" alt="Logo" className='header-img ' />
                                    <div className='headmain'>
                                        <h6 className="mb-0">Directorate, Urban Administration</h6>
                                        <h6 className="mb-0">& Development Government of</h6>
                                        <h6 className="mb-0">Madhya Pradesh</h6>
                                    </div>
                                </div>
                            </Link>
                        </div>
                        <div class="linecontainer">
                            {/* <img src="img/Headerdivider.png" className='headerimag' /> */}
                            <img src="img/gis-new header-whiet.svg" className='headerimag' />
                        </div>



                        <div className='col-xl-8 col-lg-7 col-md-7 mainheaderright'>
                            <div className='headmain'>
                                <marquee className="scrolling-text">
                                    <h6 id="scrollingText">Urban Data Analytics Center - GIS based update</h6>
                                </marquee>
                            </div>
                            <div>
                                <nav className="navbar navbar-expand-lg govt-header" >
                                    <div className='navbardiv'>
                                        <ul className="navbar-nav mx-auto">
                                            <li className="nav-item">
                                                <a className={`nav-link ${location.hash === "#home" && "active"}`} href="#home">Home</a>
                                            </li>
                                            <li className="nav-item">
                                                <a className={`nav-link ${location.hash === "#about" && "active"}`} href="#about">About Us</a>
                                            </li>
                                            <li className="nav-item">
                                                <a className={`nav-link ${location.hash === "#projects" && "active"}`} href="#projects">Projects</a>
                                            </li>
                                            <li className="nav-item">
                                                <a className={`nav-link ${location.hash === "#features" && "active"}`} href="#features">Features</a>
                                            </li>
                                            <li className="nav-item">
                                                <a className={`nav-link ${location.hash === "#contact-us" && "active"}`} href="#contact-us">Contact Us</a>
                                            </li>

                                        </ul>
                                    </div>

                                   
                                </nav>

                            </div>
                        </div>
                    </div>
                    
                </div>
            </header>

            <header className=" header-sm">
                <div className="container-fluid p-0">
                 
                    <div className="d-flex justify-content-between header-container py-2 px-0">
                        <Link to="/" style={{ textDecoration: 'none' }}>
                            <div className='mainheadertitle'>
                                <img src="img/mplogo.png" alt="Logo" className='header-img ' />
                              
                                <div className='headmain'>
                                    <h6 className="mb-0">Directorate, Urban Administration</h6>
                                    <h6 className="mb-0">& Development Government of</h6>
                                    <h6 className="mb-0">Madhya Pradesh</h6>
                                </div>
                            </div>
                        </Link>
                        <nav className="navbar navbar-expand-lg">
                            <button className="navbar-toggler ms-auto me-3" type="button" data-bs-toggle="collapse"
                                data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false"
                                aria-label="Toggle navigation"
                                onClick={handleToggle}
                            >
                                {isNavbarVisible ? (

                                    <img src="img/closebtn.svg" alt='mobile' />
                                ) : (
                                    <img src="img/mobiebtn.png" alt='mobile' />
                                )}
                            </button>
                        </nav>
                    </div>
                    <div className='navbardivsm'>
                        <div className="container">
                            <div className="header">

                            </div>
                            <div className="content">

                            </div>
                        </div>
                        <div className="collapse navbar-collapse curved-div" id="navbarNav">
                            <ul className="navbar-nav mx-auto">
                                <li className="nav-item" onClick={() => handleClose()}>
                                    <a className="nav-link " href="#home">Home</a>
                                </li>
                                <li className="nav-item" onClick={() => handleClose()}>
                                    <a className="nav-link" href="#about">About Us</a>
                                </li>
                                <li className="nav-item" onClick={() => handleClose()}>
                                    <a className="nav-link" href="#projects">Projects</a>
                                </li>
                                <li className="nav-item" onClick={() => handleClose()}>
                                    <a className="nav-link" href="#features">Features</a>
                                </li>
                                <li className="nav-item" onClick={() => handleClose()}>
                                    <a className="nav-link" href="#contact">Contact Us</a>
                                </li>
                                <li className='d-flex justify-content-center'>
                                    
                                </li>
                            </ul>
                                     <div>
                                        <div>
                                            <div className="bhashini-plugin-container"></div>
                                        </div>
                                    </div>
                        </div>
                    </div>
                </div>
            </header>
        </div>
    )
}